<template>
  <div class="register-box">
    <div class="register-head">
      <img src="@/assets/head-logo.png"/>诚云·工资条
    </div>
    <div class="resetLogin-con">
      <div class="resetLogin-main">
        <h4>{{loginForm.companyName}}</h4>
        <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="76px"
                 class="resetLogin-container">
          <el-form-item label="登录账号">
            <span class="resetLogin-span">{{loginForm.account}}</span>
          </el-form-item>
          <el-form-item label="登录密码" prop="oldPassword">
            <el-input type="text" v-model="loginForm.oldPassword" auto-complete="off" placeholder="请输入登录密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="passWord">
            <el-input type="text" v-model="loginForm.passWord" auto-complete="off" placeholder="请确认登录密码"></el-input>
          </el-form-item>
          <el-form-item style="width:100%;" class="resetLogin-btn">
            <el-button type="primary" @click.native.prevent="login">确 认</el-button>
            <el-button @click="cancel">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ChangeReg',
    data() {
        // 登录密码
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入登录密码"))
            }else{
                if (this.loginForm.passWord !== "") {
                    this.$refs.loginForm.validateField("passWord");
                }
                callback()
            }
        };
        // 确认登录密码
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.loginForm.oldPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            loginForm: {
                companyName:'',
                userId:'',
                account: '',
                oldPassword:'',
                passWord:'',
            },
            fieldRules: {
                oldPassword: [
                    { validator: validatePass, trigger: 'change' },
                    { min:6, max:20, message: '登录密码必须为6-20位', trigger: 'change'}
                ],
                passWord: [
                    { validator: validatePass2, trigger: 'change' },
                    { min:6, max:20, message: '登录密码必须为6-20位', trigger: 'change'}
                ],
            },
        }
    },
    methods: {
        // 确认
        login() {
          this.$refs.loginForm.validate((valid) => {
              if (valid) {
                  let params = {
                      userId: this.loginForm.userId,
                      passWord: this.loginForm.passWord
                  };
                  this.$api.login.updatePassWord(params).then(res => {
                      if (res.status) {
                          this.$message({message: '密码修改成功！', type: 'success'})
                          setTimeout(() => {
                              this.$router.replace('/');
                          },600);
                      } else {
                          this.$message({message: '错误提示！' + res.msg, type: 'error'})
                      }
                  })
              }
          })
        },
        // 重置
        // reset() {
        //     this.$refs.loginForm.resetFields()
        // },
        // 取消
        cancel(){
            this.$router.replace('/');
        },
    },
    created() {
      let that = this;
      document.onkeypress = function(e) {
        var keycode = document.all ? event.keyCode : e.which;
        if (keycode === 13) {
          that.login();// 登录方法名
          return false;
        }
      };
    },
    mounted() {
        // 获取登录账号的信息
        this.$api.login.getUserInfo().then(res => {
            if (res.status) {
                this.loginForm.companyName = res.data.companyInfoBasic.companyName; //所在企业
                this.loginForm.account = res.data.secUser.login_name; //登录账号
                this.loginForm.userId = res.data.secUser.id; //登录id
            } else {
                this.$message({message: '错误提示！' + res.msg, type: 'error'})
            }
        })
    },
    computed:{}
  }
</script>

<style lang="scss" scoped>
  .register-box{
    height:100%;
    overflow:hidden;
  }
  .register-head{
    width:1000px;
    margin:0 auto;
    font-size:24px;
    color:#2B2B2B;
    line-height:70px;
    text-align: left;
    font-weight:bold;
    img{
      width:51px;
      vertical-align:middle;
      margin:-8px 10px 0 0;
    }
  }
  .resetLogin-con{
    height:680px;
    background:#ecf6f8;
    padding-top:100px;
  }
  .resetLogin-main{
    width:54%;
    margin:0 auto;
    background:#fff;
    padding:30px 0 60px 0;
    -moz-box-shadow:2px 2px 5px #dddee3;
    -webkit-box-shadow:2px 2px 5px #dddee3;
    box-shadow:2px 2px 5px #dddee3;
  }
  .resetLogin-main h4{
    text-align: left;
    margin:40px 0;
    padding-left: 200px;
  }
  .resetLogin-container{
    width:400px;
    margin:0 auto;
  }
  .resetLogin-span{
    display: block;
    text-align:left;
    color: #606266;
  }
  /*确认、重置按钮*/
  .resetLogin-btn{
    text-align:left;
  }
  .resetLogin-btn button{
    width:40%;
    margin-top: 20px;
  }
  .resetLogin-btn button:last-child{
    background:#ccc;
    border-color:#ccc;
    float:right;
  }

</style>




// WEBPACK FOOTER //
// src/views/ChangeReg.vue